import { useEffect, useState } from "react";
import { useRouter } from "next/compat/router";
import { useCurrentUser } from "@hooks/use-current-user";
import { getStoryblokStory } from "@utils/call-api/storyblok-call";
import StoryblokComponent from "@components/core/Storyblok/StoryblokComponent";
import isPaymentMethodValid from "@utils/isPaymentMethodValid";
import { subscriptionStatuses } from "@utils/constants/subscriptionStatuses";
import { userSubscriptionState } from "@utils/constants/user";

function PromoBannerContainer() {
  const user = useCurrentUser();
  const router = useRouter();
  const locale = router?.locale;
  const paymentMethodValid = isPaymentMethodValid(user?.default_payment_method);
  const subscriptionIsPastDue = user?.subscription?.state === subscriptionStatuses.pastDue;

  function shouldDisplayPromoBanner() {
    if (
      [userSubscriptionState.trialing, userSubscriptionState.active].includes(
        user?.subscription?.state,
      ) &&
      !paymentMethodValid
    )
      return false;
    if (subscriptionIsPastDue) return false;

    return true;
  }

  const storySlug = `common/promobanner/${process.env.NEXT_PUBLIC_CUSTOMER}/promo-banner?language=${locale}`;

  const [story, setStory] = useState();

  const fetchStoryblokStory = async () => {
    if (!user) return;

    const storyParams = {
      ...(user?.permissions?.includes("storyblok") && { version: "draft" }),
    };

    const data = await getStoryblokStory(storySlug, storyParams);

    setStory(data.story);
  };

  useEffect(() => {
    fetchStoryblokStory();
  }, [user, locale]);

  if (!story || !shouldDisplayPromoBanner()) return null;

  return <StoryblokComponent story={story} />;
}

export default PromoBannerContainer;
